import { useMemo } from "react";
import { useGetRelatedNiches } from "./useGetRelatedNiche";
import { FeedModuleTypeEnum, IGif, INiche } from "@/common/services/types";
import { NicheCard } from "@/components/player-feed/NicheCard";
import "./NicheExplorer.scss";
import { useSfw } from "@/common/hooks/useSfw";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";

interface INicheExplorer {
  gifs: IGif[];
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const NicheExplorer = ({ gifs, moduleId, moduleType }: INicheExplorer) => {
  const { niches } = useGetRelatedNiches({ gifs });
  const { sanitizeNiche } = useSfw();

  const sanitizedNiches = useMemo(
    () => niches.map(n => sanitizeNiche(n)),
    [niches, sanitizeNiche]
  );

  const nicheItems = useMemo(() => sanitizedNiches.map((niche: INiche) => (
    <NicheCard
      key={niche.id}
      name={niche.name}
      nicheId={niche.id}
      image={niche.thumbnail}
      members={niche.subscribers}
      posts={niche.gifs}
    />
  )), [niches]);

  if (!niches.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <div className="nicheExplorer">
        <h4 className="title">Niches you might also like:</h4>
        <div className="nicheExplorerList">
          {nicheItems}
        </div>
      </div>
    </FeedModuleContainer>
  );
};
